export const GAS_FORMS = {
  "gas-safety-record": {
    type: "gas_safety_record",
    title: "Gas Safety Record",
    description: "Gas Safety (Installation and Use) Regulations inspection record",
    sections: [
      { title: "Company / Installer", fields: [
        { id: "engineer_name", label: "Engineer", type: "text" },
        { id: "company_name", label: "Company", type: "text" },
        { id: "company_address", label: "Company address", type: "text" },
        { id: "company_postcode", label: "Post code", type: "text" },
        { id: "company_phone", label: "Tel No.", type: "text" },
        { id: "gas_safe_reg", label: "Gas Safe Reg", type: "text" },
        { id: "id_card_no", label: "ID Card No.", type: "text" },
      ]},
      { title: "Job Address", fields: [
        { id: "job_name", label: "Name", type: "text" },
        { id: "job_address", label: "Address", type: "text" },
        { id: "job_postcode", label: "Post code", type: "text" },
        { id: "job_phone", label: "Tel No.", type: "text" },
      ]},
      { title: "Customer / Landlord", fields: [
        { id: "customer_name", label: "Name", type: "text" },
        { id: "customer_company", label: "Company", type: "text" },
        { id: "customer_address", label: "Address", type: "text" },
        { id: "customer_postcode", label: "Post code", type: "text" },
        { id: "customer_phone", label: "Tel No.", type: "text" },
      ]},
      { title: "Appliance 1", fields: [
        { id: "app1_location", label: "Location", type: "text" },
        { id: "app1_type", label: "Appliance type", type: "text" },
        { id: "app1_make", label: "Make", type: "text" },
        { id: "app1_model", label: "Model", type: "text" },
        { id: "app1_flue_type", label: "Flue type", type: "text" },
        { id: "app1_landlord_inspected", label: "Landlord's appliance inspected", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "app1_operating_pressure", label: "Operating pressure (mbar)", type: "text" },
        { id: "app1_heat_input", label: "Heat input (kW/h)", type: "text" },
        { id: "app1_co_high", label: "CO high rate (ppm)", type: "text" },
        { id: "app1_co2_high", label: "CO₂ high rate (%)", type: "text" },
        { id: "app1_ratio_high", label: "CO/CO₂ ratio (high)", type: "text" },
        { id: "app1_co_low", label: "CO low rate (ppm)", type: "text" },
        { id: "app1_co2_low", label: "CO₂ low rate (%)", type: "text" },
        { id: "app1_ratio_low", label: "CO/CO₂ ratio (low)", type: "text" },
        { id: "app1_safety_device", label: "Safety device(s) correct operation", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "app1_ventilation", label: "Ventilation satisfactory", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "app1_flue_visual", label: "Flue & termination visual condition satisfactory", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "app1_flue_performance", label: "Flue performance test", type: "select", options: ["Pass", "Fail", "N/A"] },
        { id: "app1_serviced", label: "Appliance serviced", type: "select", options: ["Yes", "No"] },
        { id: "app1_safe_to_use", label: "Appliance safe to use", type: "select", options: ["Yes", "No"] },
        { id: "app1_defect", label: "Defect identified", type: "textarea" },
      ]},
      { title: "Appliance 2 (if applicable)", fields: [
        { id: "app2_location", label: "Location", type: "text" },
        { id: "app2_type", label: "Appliance type", type: "text" },
        { id: "app2_make", label: "Make", type: "text" },
        { id: "app2_model", label: "Model", type: "text" },
        { id: "app2_operating_pressure", label: "Operating pressure (mbar)", type: "text" },
        { id: "app2_heat_input", label: "Heat input (kW/h)", type: "text" },
        { id: "app2_co_high", label: "CO high rate (ppm)", type: "text" },
        { id: "app2_co2_high", label: "CO₂ high rate (%)", type: "text" },
        { id: "app2_safety_device", label: "Safety device(s) correct", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "app2_ventilation", label: "Ventilation satisfactory", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "app2_safe_to_use", label: "Appliance safe to use", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "app2_defect", label: "Defect identified", type: "textarea" },
      ]},
      { title: "Safety Checks", fields: [
        { id: "co_alarm_fitted", label: "CO Alarm(s) fitted", type: "checkbox" },
        { id: "co_alarm_tested", label: "CO Alarm(s) tested and satisfactory", type: "checkbox" },
        { id: "emergency_control", label: "Emergency control accessible", type: "checkbox" },
        { id: "gas_tightness", label: "Gas tightness satisfactory", type: "checkbox" },
        { id: "pipework_visual", label: "Gas installation pipework visual inspection satisfactory", type: "checkbox" },
        { id: "equipotential_bonding", label: "Equipotential bonding satisfactory", type: "checkbox" },
      ]},
      { title: "Other Details", fields: [
        { id: "warning_notice", label: "Labels / Warning notice issued", type: "textarea" },
        { id: "next_inspection_due", label: "Next inspection due before", type: "text", placeholder: "DD/MM/YYYY" },
        { id: "comments", label: "Comments", type: "textarea" },
      ]},
    ],
  },
  "gas-warranty-registration": {
    type: "gas_warranty_registration",
    title: "Boiler Warranty / Registration Record",
    description: "Manufacturer warranty registration and customer handover record",
    sections: [
      { title: "Property & Customer", fields: [
        { id: "installation_address", label: "Installation address", type: "text" },
        { id: "postcode", label: "Postcode", type: "text" },
        { id: "customer_name", label: "Customer / owner", type: "text" },
        { id: "telephone", label: "Telephone", type: "text" },
        { id: "email", label: "Email", type: "text" },
      ]},
      { title: "Boiler Details", fields: [
        { id: "manufacturer", label: "Manufacturer", type: "text" },
        { id: "model", label: "Model", type: "text" },
        { id: "boiler_type", label: "Boiler type", type: "select", options: ["Combi", "System", "Heat only", "Other"] },
        { id: "fuel", label: "Fuel", type: "select", options: ["Natural gas", "LPG"] },
        { id: "serial_number", label: "Serial number", type: "text" },
        { id: "gc_product_code", label: "GC / product code", type: "text" },
      ]},
      { title: "Warranty Registration", fields: [
        { id: "warranty_registered", label: "Warranty registered?", type: "select", options: ["Yes", "No", "Not required"] },
        { id: "registration_date", label: "Registration date", type: "text", placeholder: "DD/MM/YYYY" },
        { id: "warranty_period", label: "Warranty period (years)", type: "text" },
        { id: "warranty_expiry", label: "Warranty expiry", type: "text", placeholder: "DD/MM/YYYY" },
        { id: "warranty_ref", label: "Registration / warranty ref.", type: "text" },
        { id: "registered_by", label: "Registered by", type: "text" },
        { id: "reg_method", label: "Registration method", type: "select", options: ["Online", "Telephone", "App", "Other"] },
        { id: "warranty_conditions_explained", label: "Warranty conditions explained", type: "checkbox" },
        { id: "annual_servicing_explained", label: "Annual servicing requirement explained", type: "checkbox" },
        { id: "proof_retained", label: "Proof of purchase / install date retained", type: "checkbox" },
      ]},
      { title: "Customer Documents Provided", fields: [
        { id: "doc_warranty_confirm", label: "Warranty confirmation / registration details", type: "checkbox" },
        { id: "doc_user_instructions", label: "Boiler user instructions", type: "checkbox" },
        { id: "doc_install_instructions", label: "Installation & servicing instructions", type: "checkbox" },
        { id: "doc_benchmark", label: "Benchmark / commissioning record", type: "checkbox" },
        { id: "doc_building_regs", label: "Building Regulations notification information", type: "checkbox" },
        { id: "doc_installer_contact", label: "Installer contact details", type: "checkbox" },
      ]},
      { title: "Notes", fields: [
        { id: "notes", label: "Notes / manufacturer conditions", type: "textarea" },
      ]},
    ],
  },
  "gas-instructions-handover": {
    type: "gas_instructions_handover",
    title: "Manufacturer Instructions Handover Record",
    description: "Confirm boiler documentation and operating information supplied to customer",
    sections: [
      { title: "Property & Appliance", fields: [
        { id: "installation_address", label: "Installation address", type: "text" },
        { id: "postcode", label: "Postcode", type: "text" },
        { id: "customer_name", label: "Customer / occupier", type: "text" },
        { id: "manufacturer", label: "Manufacturer", type: "text" },
        { id: "model", label: "Model", type: "text" },
        { id: "serial_number", label: "Serial number", type: "text" },
        { id: "boiler_type", label: "Boiler type", type: "select", options: ["Combi", "System", "Heat only"] },
      ]},
      { title: "Documents Handed Over", fields: [
        { id: "doc_user_instructions", label: "Boiler user instructions", type: "checkbox" },
        { id: "doc_install_instructions", label: "Installation & servicing instructions", type: "checkbox" },
        { id: "doc_warranty_info", label: "Manufacturer warranty information", type: "checkbox" },
        { id: "doc_controls", label: "Controls / thermostat instructions", type: "checkbox" },
        { id: "doc_programmer", label: "Programmer / smart control instructions", type: "checkbox" },
        { id: "doc_cylinder", label: "Cylinder instructions (if applicable)", type: "checkbox" },
        { id: "doc_filter", label: "Filter / system protection instructions", type: "checkbox" },
        { id: "doc_other", label: "Other accessory instructions", type: "checkbox" },
      ]},
      { title: "Customer Explanation", fields: [
        { id: "exp_on_off", label: "Boiler on/off and operating modes explained", type: "checkbox" },
        { id: "exp_ch_temp", label: "Central heating temperature control explained", type: "checkbox" },
        { id: "exp_hw_temp", label: "Hot water temperature/control explained", type: "checkbox" },
        { id: "exp_programmer", label: "Programmer / time control explained", type: "checkbox" },
        { id: "exp_thermostat", label: "Room thermostat / smart controls explained", type: "checkbox" },
        { id: "exp_pressure", label: "System pressure / filling procedure explained", type: "checkbox" },
        { id: "exp_fault", label: "How to identify a fault / fault code explained", type: "checkbox" },
        { id: "exp_reset", label: "Safe boiler reset procedure explained", type: "checkbox" },
        { id: "exp_condensate", label: "Condensate pipe / cold weather advice explained", type: "checkbox" },
        { id: "exp_gas_isolation", label: "Location of gas isolation valve identified", type: "checkbox" },
        { id: "exp_elec_isolation", label: "Location of electrical isolation identified", type: "checkbox" },
        { id: "exp_co_alarm", label: "Carbon monoxide alarm information explained", type: "checkbox" },
        { id: "exp_annual_service", label: "Need for annual servicing explained", type: "checkbox" },
        { id: "exp_emergency", label: "Emergency contact / gas emergency advice explained", type: "checkbox" },
      ]},
      { title: "Notes", fields: [
        { id: "notes", label: "Additional notes", type: "textarea" },
      ]},
    ],
  },
  "gas-installation-handover": {
    type: "gas_installation_handover",
    title: "Boiler Installation & Customer Handover Record",
    description: "Installation record for domestic gas boiler handover",
    sections: [
      { title: "Property & Installation", fields: [
        { id: "installation_address", label: "Installation address", type: "text" },
        { id: "postcode", label: "Postcode", type: "text" },
        { id: "customer_name", label: "Customer / occupier", type: "text" },
        { id: "installer_business", label: "Installer / business", type: "text" },
        { id: "gas_safe_reg", label: "Gas Safe reg. no.", type: "text" },
        { id: "engineer_name", label: "Engineer", type: "text" },
        { id: "engineer_id", label: "Engineer ID no.", type: "text" },
      ]},
      { title: "Boiler & System", fields: [
        { id: "manufacturer", label: "Manufacturer", type: "text" },
        { id: "model", label: "Model", type: "text" },
        { id: "serial_number", label: "Serial number", type: "text" },
        { id: "boiler_type", label: "Boiler type", type: "select", options: ["Combi", "System", "Heat only"] },
        { id: "fuel", label: "Fuel", type: "select", options: ["Natural gas", "LPG"] },
        { id: "system_type", label: "System type", type: "text" },
        { id: "controls_components", label: "Controls / additional components", type: "textarea" },
      ]},
      { title: "Installation / Commissioning Confirmation", fields: [
        { id: "chk_manufacturer_instructions", label: "Installation completed to manufacturer instructions", type: "checkbox" },
        { id: "chk_gas_pipework", label: "Gas supply / pipework checked", type: "checkbox" },
        { id: "chk_system_flushed", label: "System flushed / cleaned as required", type: "checkbox" },
        { id: "chk_inhibitor", label: "Inhibitor / water treatment completed", type: "checkbox" },
        { id: "chk_expansion_vessel", label: "Expansion vessel / system pressure checked", type: "checkbox" },
        { id: "chk_condensate", label: "Condensate discharge installed and checked", type: "checkbox" },
        { id: "chk_flue", label: "Flue installed, secured and visually checked", type: "checkbox" },
        { id: "chk_ventilation", label: "Ventilation requirements checked", type: "checkbox" },
        { id: "chk_commissioned", label: "Boiler commissioned to manufacturer instructions", type: "checkbox" },
        { id: "chk_combustion", label: "Combustion analysis completed", type: "checkbox" },
        { id: "chk_heating_tested", label: "Heating operation tested", type: "checkbox" },
        { id: "chk_dhw_tested", label: "Domestic hot water operation tested", type: "checkbox" },
        { id: "chk_controls_tested", label: "Controls tested and operating correctly", type: "checkbox" },
        { id: "chk_safety_devices", label: "Safety devices / interlocks checked", type: "checkbox" },
        { id: "chk_leaks", label: "Visible water / gas leaks checked", type: "checkbox" },
        { id: "chk_benchmark", label: "Benchmark checklist completed", type: "checkbox" },
        { id: "chk_warranty", label: "Manufacturer warranty registered / recorded", type: "checkbox" },
        { id: "chk_building_regs", label: "Building Regulations notification submitted / arranged", type: "checkbox" },
      ]},
      { title: "Key Commissioning Values", fields: [
        { id: "val_gas_pressure", label: "Gas inlet / working pressure (mbar)", type: "text" },
        { id: "val_gas_rate", label: "Gas rate / input", type: "text" },
        { id: "val_flow_temp", label: "Flow temperature (°C)", type: "text" },
        { id: "val_return_temp", label: "Return temperature (°C)", type: "text" },
        { id: "val_pressure_cold", label: "System pressure cold (bar)", type: "text" },
        { id: "val_pressure_hot", label: "System pressure hot (bar)", type: "text" },
        { id: "val_co", label: "CO reading (ppm)", type: "text" },
        { id: "val_co2", label: "CO₂ reading (%)", type: "text" },
        { id: "val_co_ratio", label: "CO/CO₂ ratio", type: "text" },
        { id: "val_flue_temp", label: "Flue gas temp (°C)", type: "text" },
      ]},
      { title: "Customer Handover", fields: [
        { id: "ho_operation", label: "Boiler operation demonstrated", type: "checkbox" },
        { id: "ho_heating_controls", label: "Heating controls demonstrated", type: "checkbox" },
        { id: "ho_hw_controls", label: "Hot water controls demonstrated", type: "checkbox" },
        { id: "ho_pressure", label: "System pressure / repressurising explained", type: "checkbox" },
        { id: "ho_fault_reset", label: "Fault / reset procedure explained", type: "checkbox" },
        { id: "ho_isolation", label: "Gas and electrical isolation points shown", type: "checkbox" },
        { id: "ho_co_alarm", label: "CO alarm / gas safety advice provided", type: "checkbox" },
        { id: "ho_annual_service", label: "Annual servicing requirement explained", type: "checkbox" },
        { id: "ho_instructions", label: "Manufacturer instructions provided", type: "checkbox" },
        { id: "ho_warranty", label: "Warranty information provided", type: "checkbox" },
      ]},
      { title: "Notes", fields: [
        { id: "notes", label: "Notes / outstanding items", type: "textarea" },
      ]},
    ],
  },
  "gas-boiler-service": {
    type: "gas_boiler_service",
    title: "Boiler Service / Maintenance Report",
    description: "Record findings, measurements, work completed and recommendations",
    sections: [
      { title: "Property & Customer", fields: [
        { id: "service_address", label: "Service address", type: "text" },
        { id: "postcode", label: "Postcode", type: "text" },
        { id: "customer_name", label: "Customer / occupier", type: "text" },
        { id: "telephone_email", label: "Telephone / email", type: "text" },
        { id: "next_service_due", label: "Next service due", type: "text", placeholder: "DD/MM/YYYY" },
      ]},
      { title: "Appliance Details", fields: [
        { id: "manufacturer", label: "Manufacturer", type: "text" },
        { id: "model", label: "Model", type: "text" },
        { id: "serial_number", label: "Serial number", type: "text" },
        { id: "boiler_type", label: "Boiler type", type: "select", options: ["Combi", "System", "Heat only"] },
        { id: "fuel", label: "Fuel", type: "select", options: ["Natural gas", "LPG"] },
        { id: "appliance_age", label: "Approx. appliance age", type: "text" },
      ]},
      { title: "Service / Inspection Checks", fields: [
        { id: "chk_casing", label: "Boiler casing / appliance condition satisfactory", type: "checkbox" },
        { id: "chk_gas_pipework", label: "Gas pipework / accessible joints satisfactory", type: "checkbox" },
        { id: "chk_gas_pressure", label: "Gas inlet / working pressure satisfactory", type: "checkbox" },
        { id: "chk_gas_rate", label: "Gas rate / heat input checked", type: "checkbox" },
        { id: "chk_burner", label: "Burner / heat exchanger condition satisfactory", type: "checkbox" },
        { id: "chk_ignition", label: "Ignition and flame supervision satisfactory", type: "checkbox" },
        { id: "chk_flue", label: "Flue condition / support / termination satisfactory", type: "checkbox" },
        { id: "chk_flue_seals", label: "Flue seals / joints where accessible satisfactory", type: "checkbox" },
        { id: "chk_ventilation", label: "Ventilation requirements satisfactory", type: "checkbox" },
        { id: "chk_condensate", label: "Condensate trap / drain / discharge satisfactory", type: "checkbox" },
        { id: "chk_system_pressure", label: "System pressure / expansion vessel satisfactory", type: "checkbox" },
        { id: "chk_pressure_relief", label: "Pressure relief discharge route satisfactory", type: "checkbox" },
        { id: "chk_pump", label: "Pump / circulation operation satisfactory", type: "checkbox" },
        { id: "chk_heating", label: "Heating operation satisfactory", type: "checkbox" },
        { id: "chk_dhw", label: "Domestic hot water operation satisfactory", type: "checkbox" },
        { id: "chk_controls", label: "Controls / thermostat / programmer satisfactory", type: "checkbox" },
        { id: "chk_safety", label: "Safety devices / interlocks satisfactory", type: "checkbox" },
        { id: "chk_leakage", label: "No visible signs of water leakage", type: "checkbox" },
        { id: "chk_filter", label: "System filter / magnetic filter satisfactory", type: "checkbox" },
        { id: "chk_water_condition", label: "System water condition / inhibitor satisfactory", type: "checkbox" },
        { id: "chk_co_alarm", label: "Carbon monoxide alarm present / checked", type: "checkbox" },
      ]},
      { title: "Combustion / Performance Readings", fields: [
        { id: "val_gas_pressure", label: "Gas inlet / working pressure (mbar)", type: "text" },
        { id: "val_gas_rate", label: "Gas rate / input", type: "text" },
        { id: "val_co", label: "CO reading (ppm)", type: "text" },
        { id: "val_co2", label: "CO₂ reading (%)", type: "text" },
        { id: "val_co_ratio", label: "CO/CO₂ ratio", type: "text" },
        { id: "val_o2", label: "O₂ reading (%)", type: "text" },
        { id: "val_flue_temp", label: "Flue gas temperature (°C)", type: "text" },
        { id: "val_ambient_temp", label: "Ambient / air temp (°C)", type: "text" },
        { id: "val_flow_temp", label: "Flow temperature (°C)", type: "text" },
        { id: "val_return_temp", label: "Return temperature (°C)", type: "text" },
      ]},
      { title: "Work Carried Out", fields: [
        { id: "work_completed", label: "Service / maintenance work completed", type: "textarea" },
        { id: "parts_replaced", label: "Parts replaced / materials used", type: "textarea" },
      ]},
      { title: "Defects / Recommendations", fields: [
        { id: "defects_identified", label: "Defects identified", type: "textarea" },
        { id: "remedial_work", label: "Recommended remedial work", type: "textarea" },
        { id: "appliance_operational", label: "Appliance left operational", type: "select", options: ["Yes", "No"] },
        { id: "further_work", label: "Further work required", type: "select", options: ["Yes", "No"] },
        { id: "warning_notice", label: "Warning / safety notice issued", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "reference_no", label: "Reference no.", type: "text" },
      ]},
    ],
  },
  "gas-decommissioning": {
    type: "gas_decommissioning",
    title: "Gas Appliance Decommissioning Record",
    description: "Disconnection/removal and gas supply capping record",
    sections: [
      { title: "Property / Job Details", fields: [
        { id: "property_address", label: "Property address", type: "text" },
        { id: "postcode", label: "Postcode", type: "text" },
        { id: "customer_name", label: "Customer / responsible person", type: "text" },
        { id: "job_ref", label: "Job / reference no.", type: "text" },
        { id: "property_status", label: "Property status", type: "select", options: ["Occupied", "Vacant", "Other"] },
      ]},
      { title: "Engineer / Business Details", fields: [
        { id: "business_name", label: "Gas business / trading name", type: "text" },
        { id: "business_reg", label: "Gas Safe business reg. no.", type: "text" },
        { id: "engineer_name", label: "Engineer name", type: "text" },
        { id: "engineer_id", label: "Gas Safe engineer ID no.", type: "text" },
      ]},
      { title: "Reason / Status", fields: [
        { id: "reason", label: "Primary reason for decommissioning", type: "select", options: ["Permanent appliance removal", "Replacement appliance", "Refurbishment / alteration", "Fuel change / conversion", "Unsafe / condemned appliance", "No longer required", "Temporary disconnection", "Other - see notes"] },
      ]},
      { title: "Appliance 1 Disconnected / Removed", fields: [
        { id: "app1_type", label: "Appliance type", type: "text" },
        { id: "app1_make", label: "Make", type: "text" },
        { id: "app1_model", label: "Model", type: "text" },
        { id: "app1_location", label: "Location", type: "text" },
        { id: "app1_serial", label: "Serial / ID", type: "text" },
        { id: "app1_status", label: "Status", type: "select", options: ["Removed", "Left in situ", "Temporary"] },
      ]},
      { title: "Appliance 2 (if applicable)", fields: [
        { id: "app2_type", label: "Appliance type", type: "text" },
        { id: "app2_make", label: "Make", type: "text" },
        { id: "app2_model", label: "Model", type: "text" },
        { id: "app2_location", label: "Location", type: "text" },
        { id: "app2_status", label: "Status", type: "select", options: ["Removed", "Left in situ", "Temporary", "N/A"] },
      ]},
      { title: "Gas Isolation / Capping / Sealing", fields: [
        { id: "cap1_location", label: "Supply / pipe location", type: "text" },
        { id: "cap1_isolation", label: "Isolation point", type: "text" },
        { id: "cap1_fitting", label: "Cap / plug / sealing fitting", type: "text" },
        { id: "cap1_pipework_status", label: "Pipework status", type: "select", options: ["Live capped", "Redundant", "Removed"] },
        { id: "cap2_location", label: "Supply / pipe location (2nd)", type: "text" },
        { id: "cap2_fitting", label: "Cap / plug / sealing fitting (2nd)", type: "text" },
        { id: "cap2_pipework_status", label: "Pipework status (2nd)", type: "select", options: ["Live capped", "Redundant", "Removed", "N/A"] },
      ]},
      { title: "Gas Installation Safety / Test Record", fields: [
        { id: "pre_work_test", label: "Pre-work tightness / soundness", type: "select", options: ["Pass", "Fail", "N/A"] },
        { id: "post_work_test", label: "Post-work tightness / soundness", type: "select", options: ["Pass", "Fail"] },
        { id: "test_procedure", label: "Test procedure / standard used", type: "text" },
        { id: "test_instrument", label: "Test instrument", type: "text" },
        { id: "initial_reading", label: "Initial reading / pressure", type: "text" },
        { id: "final_reading", label: "Final reading / pressure", type: "text" },
        { id: "test_duration", label: "Test duration / stabilisation", type: "text" },
        { id: "gas_escape", label: "Gas escape detected?", type: "select", options: ["No", "Yes"] },
        { id: "installation_safe", label: "Remaining installation left safe?", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "gas_supply_restored", label: "Gas supply restored?", type: "select", options: ["Yes", "No", "N/A"] },
      ]},
      { title: "Associated Make-Safe Checks", fields: [
        { id: "chk_electrical", label: "Electrical supply isolated / terminated as applicable", type: "checkbox" },
        { id: "chk_water_heating", label: "Water / heating connections made safe as applicable", type: "checkbox" },
        { id: "chk_condensate", label: "Condensate connection dealt with as applicable", type: "checkbox" },
        { id: "chk_flue", label: "Flue / terminal removed or left safe as applicable", type: "checkbox" },
        { id: "chk_openings", label: "Openings / penetrations made safe as applicable", type: "checkbox" },
        { id: "chk_pipework_labelled", label: "Redundant pipework identified / labelled where appropriate", type: "checkbox" },
        { id: "chk_area_checked", label: "Area checked following works", type: "checkbox" },
        { id: "chk_status_explained", label: "Remaining installation status explained to customer", type: "checkbox" },
      ]},
      { title: "Defects / Limitations / Further Action", fields: [
        { id: "defect_details", label: "Details", type: "textarea" },
        { id: "further_action", label: "Further action / responsible party", type: "textarea" },
      ]},
      { title: "Customer Acknowledgement", fields: [
        { id: "copy_provided", label: "Copy provided to customer", type: "select", options: ["Yes", "No"] },
      ]},
    ],
  },
  "gas-benchmark-checklist": {
    type: "gas_benchmark_checklist",
    title: "Benchmark Commissioning Checklist",
    description: "Benchmark scheme commissioning checklist for new gas boiler installations",
    sections: [
      { title: "Customer & Boiler Details", fields: [
        { id: "customer_name", label: "Customer name", type: "text" },
        { id: "customer_address", label: "Address", type: "text" },
        { id: "boiler_make_model", label: "Boiler make and model", type: "text" },
        { id: "boiler_serial", label: "Boiler serial number", type: "text" },
      ]},
      { title: "Commissioning Engineer", fields: [
        { id: "engineer_name", label: "Commissioned by (name)", type: "text" },
        { id: "company_name", label: "Company name", type: "text" },
        { id: "company_address", label: "Company address", type: "text" },
        { id: "company_phone", label: "Telephone number", type: "text" },
        { id: "gas_safe_reg", label: "Gas Safe register number", type: "text" },
        { id: "building_reg_no", label: "Building Regulations Notification Number (if applicable)", type: "text" },
      ]},
      { title: "Controls", fields: [
        { id: "ctrl_room_thermostat", label: "Room thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_prog_room_thermostat", label: "Programmable room thermostat", type: "checkbox" },
        { id: "ctrl_load_weather", label: "Load/weather compensation", type: "checkbox" },
        { id: "ctrl_optimum_start", label: "Optimum start control", type: "checkbox" },
        { id: "ctrl_cyl_thermostat", label: "Cylinder thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_heating_zone_fitted", label: "Heating zone valves — Fitted", type: "checkbox" },
        { id: "ctrl_heating_zone_not_req", label: "Heating zone valves — Not required", type: "checkbox" },
        { id: "ctrl_hw_zone_fitted", label: "Hot water zone valves — Fitted", type: "checkbox" },
        { id: "ctrl_hw_zone_not_req", label: "Hot water zone valves — Not required", type: "checkbox" },
        { id: "ctrl_trv_fitted", label: "Thermostatic radiator valves — Fitted", type: "checkbox" },
        { id: "ctrl_trv_not_req", label: "TRVs — Not required", type: "checkbox" },
        { id: "ctrl_bypass_fitted", label: "Automatic bypass — Fitted", type: "checkbox" },
        { id: "ctrl_bypass_not_req", label: "Automatic bypass — Not required", type: "checkbox" },
        { id: "ctrl_boiler_interlock", label: "Boiler interlock — Provided", type: "checkbox" },
      ]},
      { title: "All Systems", fields: [
        { id: "system_flushed", label: "System flushed and cleaned per BS7593?", type: "select", options: ["Yes", "No"] },
        { id: "system_cleaner", label: "System cleaner used", type: "text" },
        { id: "inhibitor", label: "Inhibitor used", type: "text" },
        { id: "inhibitor_quantity", label: "Quantity (litres)", type: "text" },
        { id: "primary_filter", label: "Primary water system filter installed?", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Central Heating Mode", fields: [
        { id: "ch_gas_rate", label: "Gas rate (m³/hr)", type: "text" },
        { id: "ch_burner_pressure", label: "Burner operating pressure (mbar)", type: "text" },
        { id: "ch_gas_inlet_pressure", label: "Gas inlet pressure (mbar)", type: "text" },
        { id: "ch_flow_temp", label: "CH flow temperature (°C)", type: "text" },
        { id: "ch_return_temp", label: "CH return temperature (°C)", type: "text" },
      ]},
      { title: "Combination Boilers Only", fields: [
        { id: "hard_water_area", label: "Hard water area (above 200ppm)?", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "scale_reducer_fitted", label: "Water scale reducer fitted?", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "scale_reducer_type", label: "Type of scale reducer", type: "text" },
      ]},
      { title: "Domestic Hot Water Mode", fields: [
        { id: "dhw_gas_rate", label: "Gas rate (m³/hr)", type: "text" },
        { id: "dhw_burner_pressure", label: "Burner pressure at max rate (mbar)", type: "text" },
        { id: "dhw_gas_inlet_pressure", label: "Gas inlet pressure at max rate (mbar)", type: "text" },
        { id: "dhw_cold_inlet_temp", label: "Cold water inlet temperature (°C)", type: "text" },
        { id: "dhw_outlets_checked", label: "Hot water checked at all outlets?", type: "select", options: ["Yes", "No"] },
        { id: "dhw_flow_rate", label: "Water flow rate (l/min)", type: "text" },
      ]},
      { title: "Condensing Boilers Only", fields: [
        { id: "condensate_installed", label: "Condensate drain installed per manufacturer's instructions / BS5546 / BS6798?", type: "select", options: ["Yes", "No", "N/A"] },
      ]},
      { title: "All Installations — CO / CO₂ Readings", fields: [
        { id: "co_max_ppm", label: "CO at max rate (ppm)", type: "text" },
        { id: "co_max_ratio", label: "CO/CO₂ ratio at max rate", type: "text" },
        { id: "co_min_ppm", label: "CO at min rate (ppm)", type: "text" },
        { id: "co_min_ratio", label: "CO/CO₂ ratio at min rate", type: "text" },
      ]},
      { title: "Compliance Declarations", fields: [
        { id: "complies_building_regs", label: "System complies with Building Regulations", type: "select", options: ["Yes", "No"] },
        { id: "installed_per_instructions", label: "Installed & commissioned per manufacturer's instructions", type: "select", options: ["Yes", "No"] },
        { id: "demonstrated_to_customer", label: "Operation demonstrated to and understood by customer", type: "select", options: ["Yes", "No"] },
        { id: "literature_left", label: "Manufacturer's literature & Benchmark left with customer", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Service Record (First Service)", fields: [
        { id: "service1_engineer", label: "Engineer name", type: "text" },
        { id: "service1_company", label: "Company name", type: "text" },
        { id: "service1_phone", label: "Telephone", type: "text" },
        { id: "service1_gas_safe", label: "Gas Safe register no", type: "text" },
        { id: "service1_date", label: "Date", type: "text", placeholder: "DD/MM/YYYY" },
        { id: "service1_co_max_ppm", label: "CO at max rate (ppm)", type: "text" },
        { id: "service1_co2_max", label: "CO₂ at max rate (%)", type: "text" },
        { id: "service1_co_min_ppm", label: "CO at min rate (ppm)", type: "text" },
        { id: "service1_co2_min", label: "CO₂ at min rate (%)", type: "text" },
        { id: "service1_comments", label: "Comments", type: "textarea" },
      ]},
    ],
  },
  "ashp-benchmark": {
    type: "ashp_benchmark",
    title: "Air Source Heat Pump Commissioning Benchmark",
    description: "HHIC Benchmark commissioning checklist for air-to-water heat pump installations",
    sections: [
      { title: "Installation Address & Heat Pump Details", fields: [
        { id: "address", label: "Address", type: "text" },
        { id: "hp_make_model", label: "Heat Pump make and model", type: "text" },
        { id: "hp_serial_number", label: "Heat Pump serial number", type: "text" },
        { id: "hp_type", label: "Heat Pump Type", type: "select", options: ["Split", "Monoblock"] },
        { id: "peak_heat_loss", label: "Peak heat loss of building (kW)", type: "text" },
        { id: "hp_cascade", label: "Is Heat Pump installed as part of a cascade?", type: "select", options: ["Yes", "No"] },
        { id: "hp_cascade_series", label: "Cascade Heat Pump Series (e.g. 1 of 2)", type: "text" },
        { id: "hp_refrigerant_type", label: "Heat Pump Refrigerant Type", type: "text" },
        { id: "hp_refrigerant_weight", label: "Refrigerant weight total (kg)", type: "text" },
      ]},
      { title: "Commissioning Engineer", fields: [
        { id: "engineer_name", label: "Commissioned by (name)", type: "text" },
        { id: "cert_operative_reg", label: "Certified Operative Reg number", type: "text" },
        { id: "company_name", label: "Company name", type: "text" },
        { id: "telephone", label: "Telephone number", type: "text" },
        { id: "company_email", label: "Company email", type: "text" },
        { id: "company_address", label: "Company address", type: "text" },
        { id: "commissioning_date", label: "Commissioning date", type: "text", placeholder: "DD/MM/YYYY" },
      ]},
      { title: "Compliance & Registration", fields: [
        { id: "building_regs_compliant", label: "Heating and hot water system complies with appropriate Building Regulations?", type: "select", options: ["Yes", "No"] },
        { id: "dno_notification", label: "DNO notification?", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "building_reg_number", label: "Building Regulations Notification Number (if applicable)", type: "text" },
        { id: "mcs_installer_reg", label: "MCS installer registration Number (if applicable)", type: "text" },
        { id: "mcs_product_cert", label: "MCS product certification number (if applicable)", type: "text" },
        { id: "fgas_cert", label: "F-gas certification number (split heat pump only)", type: "text" },
        { id: "g3_cert", label: "G3 certification number (if applicable)", type: "text" },
      ]},
      { title: "Electrical and Hydronic Controls — SYSTEM AND HEAT PUMP", fields: [
        { id: "ctrl_time_temp_heating", label: "Time and temperature control to heating", type: "checkbox" },
        { id: "ctrl_room_thermostat", label: "Room thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_prog_roomstat", label: "Programmable Roomstat", type: "checkbox" },
        { id: "ctrl_load_weather", label: "Load/weather compensation", type: "checkbox" },
        { id: "ctrl_optimum_start", label: "Optimum start control", type: "checkbox" },
        { id: "ctrl_time_temp_hw", label: "Time and temperature control to hot water", type: "checkbox" },
        { id: "ctrl_cyl_thermostat", label: "Cylinder thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_combined_hp", label: "Combined with Heat pump main controls", type: "checkbox" },
        { id: "ctrl_hybrid", label: "Hybrid system — synchronised control of boiler and heat pump fitted", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "ctrl_hybrid_switching", label: "If Yes — boiler model switching point (Quote Tariff or Temperature Level)", type: "text" },
      ]},
      { title: "Zone Valves & Components", fields: [
        { id: "heating_zone_status", label: "Heating zone valves (including underfloor loops)", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "hw_zone_status", label: "Hot water zone valves", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "trv_status", label: "Thermostatic radiator valves", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "outdoor_sensor_status", label: "Outdoor Sensor", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "hp_safety_interlock", label: "Heat Pump Safety Interlock", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "auto_bypass_status", label: "Automatic bypass to system", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "buffer_vessel", label: "Buffer Vessel Fitted", type: "select", options: ["Yes", "No"] },
        { id: "buffer_vessel_volume", label: "Buffer vessel volume (Litres)", type: "text" },
        { id: "plate_heat_exchanger", label: "Plate Heat Exchanger fitted for hydronic separation of heat pump circuit to heating circuit", type: "select", options: ["Yes", "No"] },
        { id: "expansion_vessel", label: "Expansion vessel for heating sized, fitted & charged per manufacturer's instructions", type: "select", options: ["Yes", "No"] },
        { id: "legionella_protection", label: "Legionella protection for stored hot water provided by timed temperature control?", type: "select", options: ["Yes", "No", "N/A"] },
      ]},
      { title: "Water Treatment — SYSTEM AND HEAT PUMP", fields: [
        { id: "system_cleaned_bs7593", label: "System cleaned and treated in accordance with BS 7593:2019 and heat pump manufacturer's instructions?", type: "select", options: ["Yes", "No"] },
        { id: "system_cleaner_brand", label: "System cleaner — Brand", type: "text" },
        { id: "system_cleaner_product", label: "System cleaner — Product", type: "text" },
        { id: "inhibitor_brand", label: "Heating system inhibitor — Brand", type: "text" },
        { id: "inhibitor_product", label: "Heating system inhibitor — Product", type: "text" },
        { id: "antifreeze_brand", label: "Anti-freeze/inhibitor (monoblock only) — Brand", type: "text" },
        { id: "antifreeze_product", label: "Anti-freeze/inhibitor — Product", type: "text" },
        { id: "antifreeze_concentration", label: "Anti-freeze/inhibitor — % concentration", type: "text" },
        { id: "system_filter_bs7593", label: "System filter fitted in accordance with BS7593:2019?", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Heat Pump Outdoor Unit", fields: [
        { id: "frost_protected", label: "Heating system adequately frost protected and pipes insulated to prevent heat loss?", type: "select", options: ["Yes", "No"] },
        { id: "refrigerant_evacuated", label: "Split only: Refrigerant circuit evacuated and charged per manufacturer's instructions", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "solid_surface", label: "Heat pump fitted on solid/stable surface capable of taking its weight", type: "select", options: ["Yes", "No"] },
        { id: "defrost_provision", label: "Necessary heat pump defrost provision put in place", type: "select", options: ["Yes", "No"] },
        { id: "fan_clear", label: "Heat pump fan free from obstacles and operational", type: "select", options: ["Yes", "No"] },
        { id: "condensate_drain", label: "Condensate drain installed to manufacturer's instructions", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Central Heating Mode", fields: [
        { id: "ch_filled_tested", label: "Heating system has been filled and pressure tested", type: "select", options: ["Yes", "No"] },
        { id: "ch_flow_temp", label: "Heating Flow Temperature (°C)", type: "text" },
        { id: "ch_return_temp", label: "Heating Return Temperature (°C)", type: "text" },
        { id: "ch_balanced", label: "System correctly balanced/rebalanced", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Domestic Hot Water Mode", fields: [
        { id: "dhw_cylinder_type", label: "Is the heat pump connected to a hot water cylinder?", type: "select", options: ["Unvented", "Vented", "Thermal Store", "Not connected"] },
        { id: "dhw_cylinder_size", label: "Hot water cylinder size (Litres)", type: "text" },
        { id: "dhw_stored_temp", label: "Stored hot water temperature (°C)", type: "text" },
        { id: "dhw_checked_all_outlets", label: "Hot water has been checked at all outlets", type: "select", options: ["Yes", "No"] },
        { id: "dhw_blending_valves", label: "Have Thermostatic Blending Valves been fitted?", type: "select", options: ["Yes", "Not required"] },
      ]},
      { title: "Additional System Information", fields: [
        { id: "water_flow_rate", label: "Water flow rate setting of the heat pump at commissioning (l/min)", type: "text" },
        { id: "additional_gas_boiler", label: "Additional heat source: Gas Boiler", type: "checkbox" },
        { id: "additional_oil_boiler", label: "Additional heat source: Oil Boiler", type: "checkbox" },
        { id: "additional_electric_heater", label: "Additional heat source: Electric Heater", type: "checkbox" },
        { id: "additional_solar_thermal", label: "Additional heat source: Solar Thermal", type: "checkbox" },
        { id: "additional_other", label: "Additional heat source: Other", type: "text" },
      ]},
      { title: "All Installations — Compliance Declarations", fields: [
        { id: "decl_electrical", label: "All electrical work complies with the appropriate Regulations", type: "select", options: ["Yes", "No"] },
        { id: "decl_installed", label: "Heat pump and associated products installed and commissioned per manufacturer's instructions", type: "select", options: ["Yes", "No"] },
        { id: "decl_demonstrated", label: "Operation of heat pump and system controls demonstrated to and understood by customer", type: "select", options: ["Yes", "No"] },
        { id: "decl_literature", label: "Manufacturer's literature, including Benchmark Checklist and Service Record, explained and left with customer", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Service Record 1", fields: [
        { id: "svc1_engineer", label: "Engineer name", type: "text" },
        { id: "svc1_company", label: "Company name", type: "text" },
        { id: "svc1_telephone", label: "Telephone No", type: "text" },
        { id: "svc1_operative_id", label: "Operative ID No", type: "text" },
        { id: "svc1_date", label: "Date", type: "text", placeholder: "DD/MM/YYYY" },
        { id: "svc1_inhibitor_checked", label: "System inhibitor concentration checked and appropriate action taken per BS 7593", type: "select", options: ["Yes", "N/a"] },
        { id: "svc1_comments", label: "Comments", type: "textarea" },
      ]},
    ],
  },
  "gshp-benchmark": {
    type: "gshp_benchmark",
    title: "Ground Source Heat Pump Commissioning Benchmark",
    description: "HHIC Benchmark commissioning checklist for ground source heat pump installations",
    sections: [
      { title: "Installation Address & Heat Pump Details", fields: [
        { id: "address", label: "Address", type: "text" },
        { id: "hp_make_model", label: "Heat Pump make and model", type: "text" },
        { id: "hp_serial_number", label: "Heat Pump serial number", type: "text" },
        { id: "hp_type", label: "Heat Pump Type", type: "select", options: ["Ground Source (Horizontal)", "Ground Source (Vertical/Borehole)", "Water Source"] },
        { id: "peak_heat_loss", label: "Peak heat loss of building (kW)", type: "text" },
        { id: "hp_refrigerant_type", label: "Heat Pump Refrigerant Type", type: "text" },
        { id: "hp_refrigerant_weight", label: "Refrigerant weight total (kg)", type: "text" },
      ]},
      { title: "Ground Loop / Collector Details", fields: [
        { id: "loop_type", label: "Ground loop type", type: "select", options: ["Horizontal slinky", "Horizontal straight", "Vertical borehole", "Open loop", "Pond/Lake"] },
        { id: "loop_length", label: "Total loop length (m)", type: "text" },
        { id: "loop_depth", label: "Loop depth / borehole depth (m)", type: "text" },
        { id: "loop_pipe_diameter", label: "Loop pipe diameter (mm)", type: "text" },
        { id: "loop_pipe_material", label: "Loop pipe material", type: "select", options: ["HDPE", "MDPE", "Copper", "Other"] },
        { id: "loop_antifreeze_type", label: "Antifreeze / glycol type", type: "text" },
        { id: "loop_antifreeze_concentration", label: "Antifreeze concentration (%)", type: "text" },
        { id: "loop_flow_rate", label: "Ground loop flow rate (l/min)", type: "text" },
        { id: "loop_pressure_tested", label: "Ground loop pressure tested?", type: "select", options: ["Yes", "No"] },
        { id: "loop_test_pressure", label: "Test pressure (bar)", type: "text" },
        { id: "loop_flushed", label: "Ground loop flushed and filled?", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Commissioning Engineer", fields: [
        { id: "engineer_name", label: "Commissioned by (name)", type: "text" },
        { id: "cert_operative_reg", label: "Certified Operative Reg number", type: "text" },
        { id: "company_name", label: "Company name", type: "text" },
        { id: "telephone", label: "Telephone number", type: "text" },
        { id: "company_email", label: "Company email", type: "text" },
        { id: "company_address", label: "Company address", type: "text" },
        { id: "commissioning_date", label: "Commissioning date", type: "text", placeholder: "DD/MM/YYYY" },
      ]},
      { title: "Compliance & Registration", fields: [
        { id: "building_regs_compliant", label: "Heating and hot water system complies with appropriate Building Regulations?", type: "select", options: ["Yes", "No"] },
        { id: "dno_notification", label: "DNO notification?", type: "select", options: ["Yes", "No", "N/A"] },
        { id: "building_reg_number", label: "Building Regulations Notification Number (if applicable)", type: "text" },
        { id: "mcs_installer_reg", label: "MCS installer registration Number (if applicable)", type: "text" },
        { id: "mcs_product_cert", label: "MCS product certification number (if applicable)", type: "text" },
        { id: "fgas_cert", label: "F-gas certification number (if applicable)", type: "text" },
      ]},
      { title: "Electrical and Hydronic Controls", fields: [
        { id: "ctrl_time_temp_heating", label: "Time and temperature control to heating", type: "checkbox" },
        { id: "ctrl_room_thermostat", label: "Room thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_prog_roomstat", label: "Programmable Roomstat", type: "checkbox" },
        { id: "ctrl_load_weather", label: "Load/weather compensation", type: "checkbox" },
        { id: "ctrl_time_temp_hw", label: "Time and temperature control to hot water", type: "checkbox" },
        { id: "ctrl_cyl_thermostat", label: "Cylinder thermostat and programmer/timer", type: "checkbox" },
        { id: "ctrl_combined_hp", label: "Combined with Heat pump main controls", type: "checkbox" },
      ]},
      { title: "Zone Valves & Components", fields: [
        { id: "heating_zone_status", label: "Heating zone valves (including underfloor loops)", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "hw_zone_status", label: "Hot water zone valves", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "trv_status", label: "Thermostatic radiator valves", type: "select", options: ["Pre-existing", "Fitted", "Not required"] },
        { id: "buffer_vessel", label: "Buffer Vessel Fitted", type: "select", options: ["Yes", "No"] },
        { id: "buffer_vessel_volume", label: "Buffer vessel volume (Litres)", type: "text" },
        { id: "expansion_vessel", label: "Expansion vessel sized, fitted & charged per manufacturer's instructions", type: "select", options: ["Yes", "No"] },
        { id: "legionella_protection", label: "Legionella protection for stored hot water?", type: "select", options: ["Yes", "No", "N/A"] },
      ]},
      { title: "Water Treatment — Heating System", fields: [
        { id: "system_cleaned_bs7593", label: "System cleaned and treated per BS 7593:2019?", type: "select", options: ["Yes", "No"] },
        { id: "system_cleaner_brand", label: "System cleaner — Brand", type: "text" },
        { id: "inhibitor_brand", label: "Heating system inhibitor — Brand", type: "text" },
        { id: "inhibitor_product", label: "Heating system inhibitor — Product", type: "text" },
        { id: "system_filter_bs7593", label: "System filter fitted per BS7593:2019?", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Central Heating Mode", fields: [
        { id: "ch_filled_tested", label: "Heating system filled and pressure tested", type: "select", options: ["Yes", "No"] },
        { id: "ch_flow_temp", label: "Heating Flow Temperature (°C)", type: "text" },
        { id: "ch_return_temp", label: "Heating Return Temperature (°C)", type: "text" },
        { id: "ch_source_inlet_temp", label: "Source inlet temperature (°C)", type: "text" },
        { id: "ch_source_outlet_temp", label: "Source outlet temperature (°C)", type: "text" },
        { id: "ch_cop_measured", label: "Measured COP (if available)", type: "text" },
        { id: "ch_balanced", label: "System correctly balanced/rebalanced", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Domestic Hot Water Mode", fields: [
        { id: "dhw_cylinder_type", label: "Heat pump connected to hot water cylinder?", type: "select", options: ["Unvented", "Vented", "Thermal Store", "Not connected"] },
        { id: "dhw_cylinder_size", label: "Hot water cylinder size (Litres)", type: "text" },
        { id: "dhw_stored_temp", label: "Stored hot water temperature (°C)", type: "text" },
        { id: "dhw_checked_all_outlets", label: "Hot water checked at all outlets", type: "select", options: ["Yes", "No"] },
        { id: "dhw_blending_valves", label: "Thermostatic Blending Valves fitted?", type: "select", options: ["Yes", "Not required"] },
      ]},
      { title: "All Installations — Compliance Declarations", fields: [
        { id: "decl_electrical", label: "All electrical work complies with appropriate Regulations", type: "select", options: ["Yes", "No"] },
        { id: "decl_installed", label: "Heat pump installed and commissioned per manufacturer's instructions", type: "select", options: ["Yes", "No"] },
        { id: "decl_demonstrated", label: "Operation demonstrated to and understood by customer", type: "select", options: ["Yes", "No"] },
        { id: "decl_literature", label: "Manufacturer's literature explained and left with customer", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Service Record 1", fields: [
        { id: "svc1_engineer", label: "Engineer name", type: "text" },
        { id: "svc1_company", label: "Company name", type: "text" },
        { id: "svc1_telephone", label: "Telephone No", type: "text" },
        { id: "svc1_date", label: "Date", type: "text", placeholder: "DD/MM/YYYY" },
        { id: "svc1_inhibitor_checked", label: "System inhibitor concentration checked per BS 7593", type: "select", options: ["Yes", "N/a"] },
        { id: "svc1_comments", label: "Comments", type: "textarea" },
      ]},
    ],
  },
  "hybrid-hp-benchmark": {
    type: "hybrid_hp_benchmark",
    title: "Hybrid Heat Pump (Gas + ASHP) Commissioning",
    description: "Benchmark checklist for combined gas boiler and air source heat pump systems",
    sections: [
      { title: "Installation Address & System Details", fields: [
        { id: "address", label: "Address", type: "text" },
        { id: "hp_make_model", label: "Heat Pump make and model", type: "text" },
        { id: "hp_serial_number", label: "Heat Pump serial number", type: "text" },
        { id: "boiler_make_model", label: "Gas Boiler make and model", type: "text" },
        { id: "boiler_serial_number", label: "Gas Boiler serial number", type: "text" },
        { id: "peak_heat_loss", label: "Peak heat loss of building (kW)", type: "text" },
      ]},
      { title: "Commissioning Engineer", fields: [
        { id: "engineer_name", label: "Commissioned by (name)", type: "text" },
        { id: "gas_safe_reg", label: "Gas Safe Reg number", type: "text" },
        { id: "company_name", label: "Company name", type: "text" },
        { id: "telephone", label: "Telephone number", type: "text" },
        { id: "commissioning_date", label: "Commissioning date", type: "text", placeholder: "DD/MM/YYYY" },
      ]},
      { title: "Hybrid System Controls", fields: [
        { id: "ctrl_hybrid_controller", label: "Hybrid controller / energy manager installed", type: "checkbox" },
        { id: "ctrl_hybrid_switching", label: "Switching point (°C or Tariff)", type: "text" },
        { id: "ctrl_boiler_priority", label: "Boiler priority above switching point", type: "checkbox" },
        { id: "ctrl_hp_priority", label: "Heat pump priority below switching point", type: "checkbox" },
        { id: "ctrl_weather_comp", label: "Weather compensation active", type: "checkbox" },
        { id: "ctrl_room_thermostat", label: "Room thermostat fitted", type: "checkbox" },
        { id: "ctrl_boiler_interlock", label: "Boiler interlock provided", type: "checkbox" },
      ]},
      { title: "Gas Boiler Commissioning", fields: [
        { id: "gas_rate", label: "Gas rate (m³/hr)", type: "text" },
        { id: "gas_inlet_pressure", label: "Gas inlet pressure (mbar)", type: "text" },
        { id: "co_max_ppm", label: "CO at max rate (ppm)", type: "text" },
        { id: "co_ratio", label: "CO/CO₂ ratio", type: "text" },
        { id: "boiler_flow_temp", label: "Boiler flow temp (°C)", type: "text" },
        { id: "boiler_return_temp", label: "Boiler return temp (°C)", type: "text" },
        { id: "flue_condition", label: "Flue condition satisfactory", type: "select", options: ["Yes", "No"] },
        { id: "gas_tightness", label: "Gas tightness satisfactory", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Heat Pump Commissioning", fields: [
        { id: "hp_flow_temp", label: "HP Flow Temperature (°C)", type: "text" },
        { id: "hp_return_temp", label: "HP Return Temperature (°C)", type: "text" },
        { id: "frost_protected", label: "Pipes insulated?", type: "select", options: ["Yes", "No"] },
        { id: "fan_clear", label: "Fan operational", type: "select", options: ["Yes", "No"] },
        { id: "condensate_drain", label: "Condensate drain installed", type: "select", options: ["Yes", "No"] },
      ]},
      { title: "Compliance Declarations", fields: [
        { id: "decl_gas_safe", label: "Gas installation complies with Gas Safety Regulations", type: "select", options: ["Yes", "No"] },
        { id: "decl_electrical", label: "Electrical work complies with Regulations", type: "select", options: ["Yes", "No"] },
        { id: "decl_installed", label: "Installed per manufacturer's instructions", type: "select", options: ["Yes", "No"] },
        { id: "decl_demonstrated", label: "Operation demonstrated to customer", type: "select", options: ["Yes", "No"] },
      ]},
    ],
  },
};

export const GAS_FORM_LIST = Object.entries(GAS_FORMS).map(([id, config]) => ({
  id,
  ...config,
}));
